import { Component } from '@angular/core';
import { PhcUrl } from '../../../../models/interfaces/portfolio-health-check-data';
import { getPHCUrls } from '../../../../utils/functions.utils';
import { AdobeAnalyticsService, CallToActionType } from 'src/app/services/adobe-analytics/adobe-analytics.service';

@Component({
  selector: 'phc-sell-accordion',
  templateUrl: './sell-accordion.component.html',
  styleUrls: ['./sell-accordion.component.scss']
})
export class SellAccordionComponent {

  urls: PhcUrl = {}

  constructor(
    private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.urls = getPHCUrls()
  }

  callToAction(name: string, type: CallToActionType) {
    this.adobeAnalyticsService.CreateCTATrigger('rebalancing-your-portfolio-sell-accordion', name, type);
  }
}
